import * as React from "react";
import styles from "./styles.module.css";
import { Checkbox } from "@/components/Shared";

const Panel: React.FC<{
	title: string;
	filters: {
		name: string;
		value: string | number;
		isChecked: boolean;
	}[];
	onChange: (evt: any) => void;
}> = ({ title, filters, onChange }) => {
	const [isOpen, setIsOpen] = React.useState<boolean>(true);

	const onClick = () => {
		setIsOpen(!isOpen);
	};

	let inputList = filters.map(function (value, index) {
		return (
			<li key={index}>
				<Checkbox
					name={value.name}
					value={value.value}
					onChange={onChange}
					isChecked={value.isChecked}
				/>
				{value.name}
			</li>
		);
	});

	return (
		<div className={`${styles["filter-panel"]}`}>
			<div className="d-flex align-items-center mb-4">
				<h3 className={`${styles["filter-panel__title"]}`}>{title}</h3>
				{isOpen ? (
					<div
						className={`${styles["filter-panel__chevron"]}`}
						onClick={onClick}
					></div>
				) : (
					<div
						className={`${styles["filter-panel__chevron"]} ${styles["filter-panel__chevron_hidden"]}`}
						onClick={onClick}
					></div>
				)}
			</div>
			{isOpen ? (
				<div className={`${styles["filter-panel__list"]} mt-3`}>
					<ul>{inputList}</ul>
				</div>
			) : null}
		</div>
	);
};

export default Panel;
